<template>
  <div class="xl:px-32 px-10 lg:px-20 md:px-14 bg-white">
    <div class="bg-white pt-5 text-center">
      <h2 class="md:text-3xl sm:text-2xl text-xl font-bold text-[#006]">
        Actividas que se realizarán en el PROCESA 2022
      </h2>
      <h3 class="text-black md:text-lg sm:text-base text-sm pt-5 text-center">
        A continuación podrás observar las diversas actividades que se
        realizarán durante los 3 días del evento.
      </h3>
    </div>
    <div class="flex justify-center pt-5 w-full pb-5">
      <img
        class="shadow-md shadow-[#231f20] rounded-xl border border-[#231f20] w-full md:w-4/5"
        src="@/assets/cronograma/agosto04x2.png"
      />
    </div>
    <div class="flex justify-center pt-2 w-full pb-5">
      <img
        class="shadow-md shadow-[#231f20] rounded-xl border border-[#231f20] w-full md:w-4/5"
        src="@/assets/cronograma/agosto05x2.png"
      />
    </div>
    <div class="flex justify-center pt-2 w-full pb-10">
      <img
        class="shadow-md shadow-[#231f20] rounded-xl border border-[#231f20] w-full md:w-4/5"
        src="@/assets/cronograma/agosto06x2.png"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
